import styled from "@emotion/styled";

export const LayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
`;

export const MainContent = styled.main`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing.xl};
  transition: background-color 0.2s ease;

  @media (max-width: 48rem) {
    padding: ${({ theme }) => theme.spacing.md};
  }
`;
